import { render } from "./DetalleSolicitudGlobalPendientes.vue?vue&type=template&id=1fe62386"
import script from "./DetalleSolicitudGlobalPendientes.vue?vue&type=script&lang=js"
export * from "./DetalleSolicitudGlobalPendientes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\prgappsolicitudes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QSpinnerBars,QTooltip,QMenu,QList,QItem,QItemSection,QSeparator,QExpansionItem,QIcon,QItemLabel,QBadge});qInstall(script, 'directives', {ClosePopup,Ripple});
